import { createContext, Dispatch, SetStateAction } from 'react'

import { FeedbackConfiguration } from 'context/materialUI/types'

export const FormContext = createContext<{
	localForm: FeedbackConfiguration
	formEdited: boolean
	setFormEdited: Dispatch<SetStateAction<boolean>>
	setLocalForm: Dispatch<SetStateAction<FeedbackConfiguration>>
}>(null)
